var styles = {
  "Backdrop": "Online-Store-UI-Backdrop_1eyhd",
  "transparent": "Online-Store-UI-Backdrop--transparent_kumsj",
  "belowNavigation": "Online-Store-UI-Backdrop--belowNavigation_1tmn2"
};

export { styles as default };
